$(document).ready(function()
{
    //https://stackoverflow.com/questions/2381336/detect-click-into-iframe-using-javascript#answer-23231136

    var signalled = [];
    var overiFrame = -1;
    var overiFrameTitle = -1;
    var post_id = $('#post_id_now').text();

    // 1. detect when an iFrame is hovered 
    $('iframe[data-engaged="video"]').hover( function() 
    {
        overiFrame = $(this).data("video-id");
        overiFrameTitle = $(this).data("video-title");
    });


    // 2. detect when window loses focus, and when so, record the blur as a faux click event
    // also record click in local js file so same user's data isn't submitted multiple times on pageload.
    $(window).blur( function() 
    {
        if( overiFrame != -1 )
        {
            
            if (signalled.hasOwnProperty(overiFrame)) 
            {
                // do nothing
            }
            else
            {
                signalled[overiFrame] = overiFrameTitle; 
                sendDataToPHP();
            }

            if (window.gaID)
            {
                gtag('event', overiFrameTitle, 
                {
                  'event_category': 'Video Play',
                  'event_label': window.location.href,
                  'transport_type':'beacon',
                });
            }

        }
    });

    // when the focus is returned, reset the hover state
    $(window).focus( function() 
    {
        overiFrame = -1;
        
    });

    function getCookieByName(name) 
    {
        var pair = document.cookie.match(new RegExp(name + '=([^;]+)'));
        return !!pair ? pair[1] : null;
    }

    function sendDataToPHP()
    {

        var data = 
        {
            'action': 'iframeTracking',
            'video_id': overiFrame,
            'video_title': overiFrameTitle,
            'user_email' : getCookieByName('downloadsEmail'),
            'post_id' : post_id, 
            'nonce': Theme_Variables.ajax_nonce,
        }
        $.post(Theme_Variables.ajax_url, data, function(response) 
        {
            //console.log(response);
        });

    }
});
